import { render, staticRenderFns } from "./ShopManage.vue?vue&type=template&id=01d545e0&scoped=true&lang=pug&"
import script from "./ShopManage.vue?vue&type=script&lang=ts&"
export * from "./ShopManage.vue?vue&type=script&lang=ts&"
import style0 from "./ShopManage.vue?vue&type=style&index=0&id=01d545e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d545e0",
  null
  
)

export default component.exports